import { RootStore, UIStore } from 'bzx-common/src/stores'
import { DialogVM } from 'bzx-common/src/ui-framework'
import * as mobx from 'mobx'

export default class HeaderVM {
  rootStore: RootStore
  uiStore: UIStore
  sideMenu = new DialogVM({ id: 'main-side-menu', transitionDelay: 200 })
  helpDialog = new DialogVM({ id: 'main-help', transitionDelay: 200 })

  hideDialogs() {
    this.sideMenu.hide()
    this.helpDialog.hide()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    this.uiStore = rootStore.uiStore
    mobx.makeAutoObservable(this, undefined, { deep: false, autoBind: true })
  }
}
